import {Component, Inject, OnInit} from "@angular/core";
import {AlertService, AuthenticationService} from "../../_services";
import {Router} from "@angular/router";
import {User} from "../../_models";
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Policy} from "../../_models/policy";

@Component({
    standalone: false,
  selector: "select-policy",
  templateUrl: 'select-policy.component.html',
  styleUrls: ['./select-policy.component.scss'],
})
export class SelectPolicyComponent implements OnInit {
  policies: Policy[] = [];
  currentUser: User;
  recurringList: any;
  controlItemId = null;

  constructor(
    public router: Router,
    public authenticationService: AuthenticationService,
    public alertService: AlertService,
    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<SelectPolicyComponent>) {
    this.policies = data.policies;
    this.controlItemId = data.controlItemId;
    this.policies.forEach(p => {
      (<any>p).popupControlMap = p.policySections.filter(s => (',' + s.controlIds + ',').indexOf(',' + this.controlItemId + ',') >= 0);
      (<any>p).isMapped = (',' + p.controlIds + ',').indexOf(',' + this.controlItemId + ',') >= 0;
    });
  }

  ngOnInit() {
  }
  selectPolicy(data)
  {
    this.dialogRef.close(data);
  }
}
